import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { CoreStore, CoreStoreSummary } from "@modules/+new/core/core-store/domain/entities/core-store.model";
import { Observable } from "rxjs";
import { Destructable } from "@models";
import { ServiceNames } from "@models/service_enums";
import { DestructorService } from "@core-services/destructor.service";
import { Helper } from "@helpers/functions";
import { ACCESS_TOKEN_KEY } from "@helpers/constants";

const initialState: CoreStoreSummary = {
	privateState: {
		requestCounter: 0
	},
	publicState: {
		isApiLoading: false,
		isLogout: false,
		isOffline: false
	}
};

@Injectable({
	providedIn: "root"
})
export class CoreStoreStateService extends StateService<CoreStoreSummary> implements Destructable {
	public name: string = ServiceNames.CORE_STORE;
	public constructor(private destructor: DestructorService) {
		super(initialState);
		destructor.register(this);
	}

	public getCoreStore$(): Observable<CoreStore> {
		return this.select((state: CoreStoreSummary) => state.publicState);
	}

	public getCoreStoreSnapshot(): CoreStore {
		return { ...this.state.publicState };
	}

	public increaseRequestCounter(): void {
		this.updateRequestCounter(1);
	}

	public decreaseRequestCounter(): void {
		this.updateRequestCounter(-1);
	}

	private updateRequestCounter(counter: number): void {
		const privateState = {
			...this.state.privateState,
			requestCounter: this.state.privateState.requestCounter + counter
		};
		const publicState = { ...this.state.publicState, isApiLoading: privateState.requestCounter > 0 };
		this.setState({ privateState, publicState });
	}

	public updateLogoutState(isLogout: boolean): void {
		this.setState({ publicState: { ...this.state.publicState, isLogout } });
	}

	public updateOfflineState(isOffline: boolean): void {
		this.setState({ publicState: { ...this.state.publicState, isOffline } });
	}

	public updateAccessToken(accessToken: string): void {
		Helper.setCookie(ACCESS_TOKEN_KEY, accessToken);
	}

	public clearAccessToken(): void {
		this.updateAccessToken(null);
	}

	public getAccessToken(): string {
		return Helper.getCookie(ACCESS_TOKEN_KEY);
	}

	public hasAccessToken(): boolean {
		const accessToken: string = this.getAccessToken();
		if (!accessToken) {
			return false;
		}
		return accessToken.length > 0 && accessToken !== "null";
	}

	public destroy(): void {
		this.setState({ ...initialState, publicState: { ...initialState.publicState, isLogout: true } });
		this.clearAccessToken();
	}
}
